module.exports = __webpack_public_path__ + "img/solution5.573110a9.jpg";